module.exports = __webpack_public_path__ + "img/flag_en.e8b278a0.png";